'use strict'

var emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
var phoneRe = /^\+?[0-9\(\)\-\s\.]{6,16}$/im

module.exports = {
	email: function(email) {
		return emailRe.test(email)
	},
	phone: function(phone) {
		return phoneRe.test(phone)
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./helpers/validate.js
 ** module id = 167
 ** module chunks = 0
 **/